import callApi from 'lib/callApi';

export async function fetchPostureDetail(id, companyId) {
  let url = `/pcm/posture/${id}/`;
  const data = await callApi(url, 'GET', { company_id: companyId })
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}

export function processJsonData(json) {
  let instanceValue = json.instance;
  let parsedInstance: Record<string, unknown> | null = null;

  // Try to parse if it's a string
  if (typeof instanceValue === 'string') {
    try {
      const parsed = JSON.parse(instanceValue);
      // Only use parsed if it's a non-null object (not a primitive)
      if (parsed && typeof parsed === 'object') {
        parsedInstance = parsed;
      }
    } catch {
      // Not a JSON string, will handle below
    }
  } else if (instanceValue && typeof instanceValue === 'object') {
    parsedInstance = instanceValue;
  }

  // If we got an object, use it; otherwise, wrap as { instance: <string> }
  const instance_details =
    parsedInstance !== null ? parsedInstance : { instance: instanceValue };

  let parsedEvidence;
  if (json?.evidence) {
    const evidence = json.evidence;
    parsedEvidence = {
      evidence: evidence.evidence || null,
      decoded_evidence: evidence.decoded_evidence?.[0] || null,
    };
  }

  const processedJson = {
    ...json,
    policy: {
      policy_id: json.policy_id,
      policy_display_name: json.policy_display_name,
      evaluation_date: json.evaluation_date,
    },
    instance_details: {
      technology_name: json.technology_name,
      instance: instance_details,
    },
    evidence: {
      evidence: parsedEvidence?.evidence,
      decoded_evidence: parsedEvidence?.decoded_evidence,
    },
    control: {
      control_statement: json.control_statement,
      control_criticality_label: json.control_criticality_label,
      control_category: json.control_category,
      control_sub_category: json.control_sub_category,
      control_ignore_error: json.control_ignore_error,
      control_deprecated: json.control_deprecated,
      control_deprecated_date: json.control_deprecated_date,
      control_modified_date: json.control_modified_date,
    },
    host: {
      host_id: json.host_id,
      host_name: json.host_name,
      host_alias: json.host_alias,
      host_ip: json.host_ip,
    },
  };
  return processedJson;
}
